import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <main className="md:ml-72 min-h-screen flex flex-col">
        <div
          key={pathname}
          className="p-4 md:p-8 pt-20 md:pt-8 flex-1 animate-in fade-in slide-in-from-bottom-4 duration-500"
        >
          {children}
        </div>
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
